module.exports = {

    greenTile: {
        scale: {
            x: '100%',
            y: '100%',
        },
        texture: '/img/tiles/onf-green.png',
    },

    beigeTile: {
        scale: {
            x: '100%',
            y: '100%',
        },
        texture: '/img/tiles/onf-beige.png',
    },

    darkGreenTile: {
        scale: {
            x: '100%',
            y: '100%',
        },
        texture: '/img/tiles/onf-darkgreen.png',
    },

    grayTile: {
        scale: {
            x: '100%',
            y: '100%',
        },
        texture: '/img/tiles/onf-gray.png',
    },

};



// WEBPACK FOOTER //
// ./js/objects/general/tiles.js